<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-checkbox-marked-outline" title="Daily attendance">
        <v-card flat class="px-2">
          <v-row>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">
                Class
              </label>
              <v-autocomplete
                placeholder="--Select--"
                class="my-0 py-1"
                name="classSelect"
                v-model="selectedClassID"
                required
                v-on:change="changeSections()"
                item-value="id"
                :items="classes"
                key="id"
                :item-text="item => item.name + ` (${item.studentClassCount || 0})`"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">
                Section
              </label>
              <v-autocomplete
                placeholder="--Select--"
                class="my-0 py-1"
                name="sectionSelect"
                v-model="selectedSectionID"
                required
                item-value="id"
                :items="classWiseSections"
                key="id"
                :item-text="item => item.name + ` (${item.studentSectionCount || 0})`"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">
                Date
              </label>
              <custom-date-picker v-model="selectedDate" :maxToDate="maxToDate" @input="dateChanged()"/>
            </v-col>
            <v-col cols="12" md="6">
              <span class="font-weight-medium body-2">Action</span>
              <div class="inside">
                <v-btn elevation="1" color="success" @click="getAttendance()"><v-icon left>mdi-magnify</v-icon>Get</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <section class="section is-title-bar">
          Total Records :
          <b>{{ totalStudents }}</b>
        </section>

        <section class="section is-main-section">
          <b-table :checkable="isWrite" :checked-rows.sync="checkedRows" :hoverable="true" :data="viewModeData" detailed @check="checkDone" @check-all="checkDone">
            <template slot-scope="props">
              <b-table-column label="Name" field="studentname">
                {{ props.row.studentEnrollment.studentName }}
              </b-table-column>

              <b-table-column label="Gender" field="gender">
                {{ props.row.studentEnrollment.gender === 'MALE' || props.row.studentEnrollment.gender === 'Male' ? 'Boy':props.row.studentEnrollment.gender === 'FEMALE' || props.row.studentEnrollment.gender === 'Female'? 'Girl'  : props.row.studentEnrollment.gender || props.row.studentEnrollment.gender==="BOY"? 'Boy':props.row.studentEnrollment.gender || props.row.studentEnrollment.gender==='GIRL'? 'Girl' :props.row.studentEnrollment.gender  }}
              </b-table-column>
              <b-table-column label="Attendance" field="isPresent">
                {{ props.row.attendanceRecord ? (props.row.attendanceRecord.isPresent ? 'Present' : 'Absent') : 'No Records found' }}
              </b-table-column>

              <b-table-column label="Remark" field="remark">
                <b-field>
                  <b-select :disabled="!isWrite" v-if="isThisChecked(props.row.id)" placeholder="Select a present remark" v-model="resn[props.index]">
                    <option v-for="option in presentRemarks" :value="option.id" :key="option.id">
                      {{ option.remark }}
                    </option>
                  </b-select>
                  <b-select :disabled="!isWrite" v-else placeholder="Select a absent remark" v-model="resn[props.index]">
                    <option v-for="option in absentRemarks" :value="option.id" :key="option.id">
                      {{ option.remark }}
                    </option>
                  </b-select>
                </b-field>
              </b-table-column>
              <b-table-column :visible="isWrite" label="Edit" width="140" centered>
                <div v-if="props.row.attendanceRecord" class="buttons">
                  <button class="button is-small" title="Edit attendance" @click="modalOpen(props.row.attendanceRecord.id)">
                    <b-icon icon="pencil" size="is-small"></b-icon>
                  </button>
                </div>
              </b-table-column>

              <b-table-column label="report" width="140" centered>
                <div class="buttons">
                  <button class="button is-small" title="Attendance report" @click="reportModalOpen(props.row.id)">
                    <b-icon icon="chart-histogram" size="is-small"></b-icon>
                  </button>
                </div>
              </b-table-column>
            </template>
            <template slot="detail" slot-scope="props">
              <div class="columns">
                <div class="column">
                  <p>
                    <b>DOB:</b>
                    <span>{{ props.row.studentEnrollment.dateOfBirth }}</span>
                  </p>
                </div>
                <div class="column">
                  <p>
                    <b>Address:</b>
                    <span>{{ props.row.studentEnrollment.address }}</span>
                  </p>
                </div>
                <div class="column">
                  <p>
                    <b>City:</b>
                    <span>{{ props.row.studentEnrollment.city }}</span>
                  </p>
                </div>
                <div class="column">
                  <p>
                    <b>State:</b>
                    <span>{{ props.row.studentEnrollment.state }}</span>
                  </p>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <p>
                    <b>Country:</b>
                    <span>{{ props.row.studentEnrollment.countryName }}</span>
                  </p>
                </div>
                <div class="column">
                  <p>
                    <b>Locality:</b>
                    <span>{{ props.row.studentEnrollment.locality }}</span>
                  </p>
                </div>
                <div class="column">
                  <p>
                    <b>Pincode:</b>
                    <span>{{ props.row.studentEnrollment.pincode }}</span>
                  </p>
                </div>
                <div class="column"></div>
              </div>
              <div class="columns">
                <div class="column">
                  <p>
                    <b>Parent Name:</b>
                    <span>{{ props.row.studentEnrollment.fatherName }}</span>
                  </p>
                </div>
                <div class="column">
                  <p>
                    <b>Parent Mobile:</b>
                    <span>{{ props.row.studentEnrollment.fatherMobile }}</span>
                  </p>
                </div>
                <div class="column">
                  <p>
                    <b>Parent Email:</b>
                    <span>{{ props.row.studentEnrollment.fatherEmailID }}</span>
                  </p>
                </div>
                <div class="column"></div>
              </div>
              <div class="columns">
                <div class="column">
                  <p>
                    <b>Mother Name:</b>
                    <span>{{ props.row.studentEnrollment.motherName }}</span>
                  </p>
                </div>
                <div class="column">
                  <p>
                    <b>Mother Mobile:</b>
                    <span>{{ props.row.studentEnrollment.motherMobile }}</span>
                  </p>
                </div>
                <div class="column">
                  <p>
                    <b>Mother Email:</b>
                    <span>{{ props.row.studentEnrollment.motherEmailID }}</span>
                  </p>
                </div>
                <div class="column">
                  <p>
                    <b>Enrollment Code:</b>
                    <span>{{ props.row.studentEnrollment.enrollmentCode }}</span>
                  </p>
                </div>
              </div>
              <div class="columns"></div>
              <div class="columns"></div>
            </template>
            <section class="section" slot="empty">
              <div class="content has-text-grey has-text-centered">
                <template>
                  <p>
                    <b-icon icon="emoticon-sad" size="is-large" />
                  </p>
                  <p>Nothing's here&hellip;</p>
                </template>
              </div>
            </section>
          </b-table>
          <b-modal
            v-model="modalOk"
            :active="modalOk"
            :on-cancel="
              () => {
                modalOk = false
              }
            "
          >
            <div class="card">
              <div class="card-content">
                <section class="modal-card-body">
                  <div class="field">
                    <b-checkbox v-model="singleData.isPresent" @input="singleCheckboxChange()">
                      Is present
                    </b-checkbox>
                  </div>

                  <b-field>
                    <b-select v-if="singleData.isPresent" placeholder="Select a present remark" v-model="singleData.remark">
                      <option v-for="option in presentRemarks" :value="option.id" :key="option.id">
                        {{ option.remark }}
                      </option>
                    </b-select>
                    <b-select v-else placeholder="Select a absent remark" v-model="singleData.remark">
                      <option v-for="option in absentRemarks" :value="option.id" :key="option.id">
                        {{ option.remark }}
                      </option>
                    </b-select>
                  </b-field>
                </section>
                <footer class="modal-card-foot">
                  <button class="button" type="button" @click="modalOk = false">Close</button>
                  <button class="button is-primary" @click="singleUpdate">Save</button>
                </footer>
              </div>
            </div>
          </b-modal>

          <b-modal
            full-screen
            v-model="reportModalOk"
            :active="reportModalOk"
            :on-cancel="
              () => {
                ;(reportModalOk = false), (reportData = [])
              }
            "
          >
            <div class="modal-card">
              <section class="modal-card-body">
                <b-table :data="reportData">
                  <template slot-scope="props">
                    <b-table-column label="Month" field="Month" :visible="!monthOk">
                      <a @click="getReport(props.row.Month, props.row.year)"> {{ props.row.Month }}</a>
                    </b-table-column>
                    <b-table-column label="Date" field="date" :visible="monthOk">
                      {{ props.row.date }}
                    </b-table-column>
                    <b-table-column label="absent" field="absent">
                      {{ props.row.absent }}
                    </b-table-column>
                    <b-table-column label="present" field="present">
                      {{ props.row.present }}
                    </b-table-column>
                    <b-table-column label="year" field="year" :visible="!monthOk">
                      {{ props.row.year }}
                    </b-table-column>
                  </template>
                </b-table>
              </section>
              <footer class="modal-card-foot">
                <button class="button" type="button" @click="closeReportModal()">Close</button>
                <button
                  v-if="monthOk"
                  class="button is-primary"
                  @click="
                    () => {
                      ;(monthOk = false), getReport()
                    }
                  "
                >
                  Back
                </button>
              </footer>
            </div>
          </b-modal>

          <footer v-if="isWrite" class="column has-text-right">
            <button :disabled="selectedClassID === '' || selectedSectionID === '' || academicYearID === '' || franchiseeID === '' || viewModeData.length === 0" class="button is-success" @click="save">
              Save
            </button>
          </footer>
        </section>
      </material-card>
    </v-container>
    <loading-icon :value="isLoading" />
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
// import VCardComponent from '@/components/template/VCardComponent'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Utils from '@/utils'
import _ from 'lodash'

export default {
  name: 'attendance',
  components: {
    MaterialCard,
    CustomDatePicker
    // VCardComponent
  },
  data () {
    return {
      franchiseeID: '',
      selectedClassID: '',
      selectedSectionID: '',
      isLoading: false,
      classWiseSections: [],
      classes: [],
      loadingComponent: null,
      totalStudents: 0,
      academicYearID: '',
      academicYears: [],
      checkedRows: [],
      resn: [],
      selectedDate: null,
      isViewMode: true,
      toDate: new Date(),
      viewModeData: [],
      modalOk: false,
      singleData: [],
      presentRemarks: [],
      absentRemarks: [],
      singleId: '',
      remarkOk: true,
      inProgress: false,
      maxToDate: moment().format('YYYY-MM-DD'),
      isWrite: false,
      reportModalOk: false,
      idForReport: '',
      reportData: [],
      monthOk: false
    }
  },
  created: async function () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    this.selectedDate = moment().format('YYYY-MM-DD')
    await this.onStart()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      this.clearInputs()
      this.classWiseSections = []
      this.classes = []
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      this.clearInputs()
      this.classWiseSections = []
      this.classes = []
      await this.onFranchiseeChange()
    },
    selectedClassID () {
      this.selectedSectionID = ''
    }
  },
  methods: {
    dateChanged () {
      if (moment(this.selectedDate).day() === 0) {
        this.errMsg('Kindly select day other than Sunday!')
        this.selectedDate = null
      }
    },
    singleCheckboxChange () {
      this.singleData.remark = undefined
    },
    closeReportModal () {
      this.monthOk = false
      this.reportModalOk = false
      this.reportData = []
    },
    getReport: async function (mnth, yr) {
      let url
      if (mnth) {
        this.monthOk = true
        let startOfMonth = moment()
          .year(yr)
          .month(mnth)
          .startOf('month')
          .format('MM/DD/YYYY')
        let endOfMonth = moment()
          .year(yr)
          .month(mnth)
          .endOf('month')
          .format('MM/DD/YYYY')
        url = `${constants.API_URL}/api/attendance/student/count?franchiseeID=${this.franchiseeID}&&studentAdmissionsID=${this.idForReport}&&isMonth=false&&fromDate=${startOfMonth}&&toDate=${endOfMonth}`
      } else {
        url = `${constants.API_URL}/api/attendance/student/count?franchiseeID=${this.franchiseeID}&&studentAdmissionsID=${this.idForReport}`
      }

      try {
        this.isLoading = true
        let res = await http.get(url)

        this.reportData = res.data.attendanceRecords
        console.log(this.reportData, 'reportData')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    reportModalOpen (id) {
      this.reportModalOk = true
      this.idForReport = id
      this.getReport()
    },
    onStart: async function () {
      this.getRemarks()
      this.dateChanged()
    },
    modalOpen (id) {
      this.modalOk = true
      this.singleId = id
      this.getSingleData()
    },
    singleUpdate: async function () {
      this.isLoading = true

      if (this.singleData.isPresent === true) {
        if (this.singleData.remark === undefined) {
          this.singleData.remark = 8
        }
        let r = this.presentRemarks.some(b => parseInt(this.singleData.remark) === b.id)
        if (!r) {
          this.isLoading = false
          this.errMsg('Present remark is given for absent student!')
          this.remarkOk = false
          return false
        }
      } else if (this.singleData.isPresent === false) {
        if (this.singleData.remark === undefined) {
          this.singleData.remark = 7
        }
        let r2 = this.absentRemarks.some(b => parseInt(this.singleData.remark) === b.id)
        if (!r2) {
          this.isLoading = false
          this.errMsg('Absent remark is given for present student!')
          this.remarkOk = false
          return false
        }
      }

      try {
        let res = await http.put(`${constants.API_URL}/api/attendance/student/${this.singleId}`, {
          isPresent: this.singleData.isPresent,
          remark: this.singleData.remark
        })
        this.okMsg(res.data)
        this.isLoading = false
        this.modalOk = false
        this.getAttendance()
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getSingleData: async function () {
      try {
        let { data } = await http.get(`${constants.API_URL}/api/attendance/student/${this.singleId}`)
        this.singleData = data[0].attendanceRecords[0]
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    save: async function () {
      this.isLoading = true
      let attendanceArr = this.viewModeData.map(a => {
        let x = this.checkedRows.some(b => {
          return a.id === b.id
        })
        return {
          studentAdmissionsID: a.id,
          isPresent: x
        }
      })

      attendanceArr.map((x, i) => {
        if (this.resn.length > 0) {
          this.resn.map((y, j) => {
            if (i === j && y !== null && y !== undefined) {
              x.remark = y
            } else {
              if (x.isPresent === true) {
                if (!x.remark || x.remark === null || x.remark === undefined) {
                  x.remark = 8
                }
              } else {
                if (!x.remark || x.remark === null || x.remark === undefined) {
                  x.remark = 7
                }
              }
            }
          })
        } else {
          if (x.isPresent === true) {
            if (!x.remark || x.remark === null || x.remark === undefined) {
              x.remark = 8
            }
          } else {
            if (!x.remark || x.remark === null || x.remark === undefined) {
              x.remark = 7
            }
          }
        }
      })
      attendanceArr.map(a => {
        if (a.isPresent === true) {
          let r = this.presentRemarks.some(b => a.remark === b.id)
          if (!r) {
            a.remark = 8
            // this.isLoading = false
            // this.errMsg('Present remark is given for absent student!')
            // this.remarkOk = false
            // return false
          }
        } else if (a.isPresent === false) {
          let r2 = this.absentRemarks.some(b => a.remark === b.id)
          if (!r2) {
            a.remark = 7
            // this.isLoading = false
            // this.errMsg('Absent remark is given for present student!')
            // this.remarkOk = false
            // return false
          }
        }
      })

      if (this.remarkOk) {
        let formData = {
          franchiseeID: this.franchiseeID,
          classID: this.selectedClassID,
          sectionID: this.selectedSectionID,
          academicYearID: this.academicYearID,
          date: moment(this.selectedDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
          studentAttendance: attendanceArr
        }
        try {
          await http.post(`${constants.API_URL}/api/attendance/student`, formData)
          this.okMsg('Attendance saved successfully!!')
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        }
        this.clearInputs()
        this.isLoading = false
      } else {
        this.isLoading = false
        this.remarkOk = true
      }
    },
    checkDone (e, i) {
      this.checkedRows = e
      if (i) {
        let tblDataIDs = _.map(this.viewModeData, a => a.id)
        tblDataIDs.map((a, j) => {
          if (a === i.id) {
            this.resn[j] = undefined
          }
        })
      } else {
        this.viewModeData.map((a, i) => {
          let absentIds = this.absentRemarks.map(b => b.id)
          if (absentIds.includes(parseInt(a.attendanceRecord.remark))) {
            this.resn[i] = undefined
          }
        })
      }
    },
    viewModeToggle () {
      this.isViewMode = !this.isViewMode
      this.clearInputs()
    },
    getAttendance: async function () {
      if (!this.franchiseeID) {
        this.errMsg('Kindly select franchisee Value!!')
        return false
      } else if (!this.selectedClassID) {
        this.errMsg('Kindly select class Value!!')
        return false
      } else if (!this.selectedSectionID) {
        this.errMsg('Kindly select section Value!!')
        return false
      } else if (!this.academicYearID) {
        this.errMsg('Kindly select Academic year Value!!')
        return false
      } else if (!this.selectedDate) {
        this.errMsg('Kindly select date!!')
        return false
      }
      try {
        this.isLoading = true

        let atndnceData = await http.get(
          `${constants.API_URL}/api/attendance/student?franchiseeID=${this.franchiseeID}&classID=${this.selectedClassID}&academicYearID=${this.academicYearID}&sectionID=${this.selectedSectionID}&date=${this.selectedDate}`
        )
        let temp = atndnceData.data
        let r = temp
          .map(a => {
            if (a.attendanceRecords[0]) {
              if (a.attendanceRecords[0].isPresent) {
                return a
              }
            } else {
              return a
            }
          })
          .filter(a => a)
        this.checkedRows = r

        let tempr = temp.map(a => {
          if (a.attendanceRecords[0]) {
            if (a.attendanceRecords[0].remark) {
              return parseInt(a.attendanceRecords[0].remark)
            }
          }
          //  else {
          //   return false
          // }
        })
        this.resn = tempr

        if (atndnceData.data.length > 0) {
          this.viewModeData = atndnceData.data
          let x = this.viewModeData.map(a => {
            a.attendanceRecord = a.attendanceRecords[0]
            a.studentEnrollment.dateOfBirth = moment(a.studentEnrollment.dateOfBirth, 'YYYY-MM-DD').format('YYYY-MM-DD')
            return a
          })
          this.viewModeData = x
        } else {
          this.viewModeData = []
        }
        this.totalStudents = this.viewModeData.length
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    isThisChecked (e) {
      let p = this.checkedRows.some(a => {
        return a.id === e
      })
      return p
    },
    clearInputs () {
      this.selectedClassID = ''
      this.selectedSectionID = ''
      this.viewModeData = []
      this.checkedRows = []
      this.totalStudents = 0
      this.classWiseSections = []
    },

    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        // await this.onStart()
        this.inProgress = false
      }
      if (this.academicYearID && this.franchiseeID) {
        this.getClassList()
      }
    },
    getRemarks: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/attendance/remarks`)
        this.presentRemarks = data.filter(a => a.isPresentRemark)
        this.absentRemarks = data.filter(a => !a.isPresentRemark)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    getClassList: async function () {
      if (!this.franchiseeID) {
        this.errMsg('Kindly select franchisee!')
        return false
      } else if (!this.academicYearID) {
        this.errMsg('Kindly select academic year!')
        return false
      }

      if (this.franchiseeID && this.academicYearID) {
        try {
          this.isLoading = true
          const { data } = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=true`)
          if (data) {
            this.classes = data
            this.sections = data
          } else {
            this.classes = []
            this.sections = []
          }
        } catch (e) {
          this.classes = []
          this.sections = []
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        } finally {
          this.isLoading = false
        }
      } else {
        this.classes = []
        this.sections = []
      }
    },

    changeSections: async function () {
      try {
        this.isLoading = true
        let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
        if (sectionarray) {
          this.classWiseSections = sectionarray.studentSections
        } else {
          this.classWiseSections = []
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style scoped>
.to-bottom {
  align-self: flex-end;
}
</style>
